import { GetMethod, PostMethod } from '../../serviceHelper';

const getMethods = (service: 'workflow', controller: 'MenuManager') => ({
	GetActionParameters: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetActionParameters'
	}),
	GetUserMenuStructure: new GetMethod<any, null>({
		service,
		controller,
		method: 'GetUserMenuStructure'
	}),
	GetDesignMenuStructure: new GetMethod<any, null>({
		service,
		controller,
		method: 'GetDesignMenuStructure'
	}),
	SaveDesignMenuStructure: new PostMethod<any, any>({
		service,
		controller,
		method: 'SaveDesignMenuStructure'
	}),
	GeteBA6approvalsUrl: new PostMethod<any, any>({
		service,
		controller,
		method: 'GeteBA6approvalsUrl'
	}),
	GeteBA6MenuItemUrl: new PostMethod<any, any>({
		service,
		controller,
		method: 'GeteBA6MenuItemUrl'
	}),
	GeteBA6historyUrl: new PostMethod<any, any>({
		service,
		controller,
		method: 'GeteBA6historyUrl'
	}),
	RecentlyMenuItems: new GetMethod<any, any>({
		service,
		controller,
		method: 'RecentlyMenuItems'
	}),
	OpenMenuItem: new PostMethod<any, any>({
		service,
		controller,
		method: 'OpenMenuItem'
	}),
	PinRecentlyMenuItem: new PostMethod<any, any>({
		service,
		controller,
		method: 'PinRecentlyMenuItem'
	}),
	GetSupersetEmbedDashboardInfo: new PostMethod<any, any>({
		service,
		controller,
		method: 'GetSupersetEmbedDashboardInfo'
	})
});

export { getMethods };
